export default __webpack_public_path__ + "static/media/landlords.f5854fa2.svg";